import { useEffect, useRef } from 'react';

const useBroadcastChannel = (channelName, onMessage) => {
  const isUnmounted = useRef(false);
  let channelRef = useRef(null);

  useEffect(() => {
    channelRef.current = new BroadcastChannel(channelName);
    isUnmounted.current = false;

    // Set up the message listener
    const handleMessage = (event) => {
      if (onMessage) {
        onMessage(event.data);
      }
    };
    channelRef.current.addEventListener('message', handleMessage);

    // Clean up on component unmount
    return () => {
      if (channelRef.current) {
        channelRef.current.removeEventListener('message', handleMessage);
        channelRef.current.close();
        isUnmounted.current = true;
      }
    };
  }, [channelName, onMessage]);

  // Function to send a message
  const broadcastMessage = (message = '') => {
    if (!isUnmounted.current && channelRef.current) {
      channelRef?.current?.postMessage(message);
    }
  };

  return { broadcastMessage };
};

export default useBroadcastChannel;
